var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coming_soon_container",attrs:{"dir":"ltr"}},[_c('h3',[_vm._v("COMING SOON")]),_c('div',{staticClass:"bar"},[_c('div',{staticClass:"progress"})])])
}]

export { render, staticRenderFns }